export default "__VITE_ASSET__22878567__"